export const TABLET_HEADER_HEIGHT = 60;
export const MOBILE_HEADER_HEIGHT = 50;
export const TABLET_MARGIN_HORIZONTAL = 35;
export const MOBILE_MARGIN_HORIZONTAL = 15;
